import { Button, Dialog, Inline, Stack, Text, vars } from '@etg/wings';
import { useTranslation } from '@eti/providers';
import { css } from '@eti/styles';
import ProductDrawerCard from '../../common/components/ProductDrawerCard';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const dialogCardStyle = css`
  border: 1px solid ${vars.colors.divider};
`;
const LoungeInfoDialog = ({
  isOpen,
  segment,
  onClose,
  dataTestId = 'lounge-pnc-info-dialog'
}) => {
  var _ref, _info$loungeName;
  const {
    t
  } = useTranslation();
  const info = segment === null || segment === void 0 ? void 0 : segment.loungeInfo;
  return /*#__PURE__*/_jsx(Dialog, {
    closeButtonAriaLabel: t('ScreenReader.CloseButtonDialog.AriaLabel.Text'),
    "data-testid": dataTestId,
    footer: /*#__PURE__*/_jsx(Inline, {
      align: "end",
      spacing: 8,
      children: /*#__PURE__*/_jsx(Button, {
        onClick: onClose,
        variant: "primary",
        children: t('Close')
      })
    }),
    isOpen: isOpen,
    onDismiss: onClose,
    title: (_ref = (_info$loungeName = info === null || info === void 0 ? void 0 : info.loungeName) !== null && _info$loungeName !== void 0 ? _info$loungeName : segment === null || segment === void 0 ? void 0 : segment.departureAirport) !== null && _ref !== void 0 ? _ref : '',
    children: /*#__PURE__*/_jsxs(Stack, {
      spacing: 16,
      children: [(info === null || info === void 0 ? void 0 : info.openAt) && (info === null || info === void 0 ? void 0 : info.closeAt) && /*#__PURE__*/_jsx(ProductDrawerCard, {
        className: dialogCardStyle,
        headingLevel: 3,
        cardTitle: t('loungePerSegmentDialogOpeningTitle'),
        children: /*#__PURE__*/_jsx(Text, {
          asHtml: true,
          children: t('loungePerSegmentDialogOpeningHoursDescription', info.openAt, info.closeAt)
        })
      }), (info === null || info === void 0 ? void 0 : info.amenities) && info.amenities.length > 0 && /*#__PURE__*/_jsx(ProductDrawerCard, {
        className: dialogCardStyle,
        headingLevel: 3,
        cardTitle: t('loungePerSegmentDialogAmenities'),
        children: /*#__PURE__*/_jsx("ul", {
          children: info.amenities.map((amenity, index) => {
            var _ref2, _amenity$code;
            return /*#__PURE__*/_jsx("li", {
              children: amenity.name
            }, (_ref2 = (_amenity$code = amenity.code) !== null && _amenity$code !== void 0 ? _amenity$code : amenity.name) !== null && _ref2 !== void 0 ? _ref2 : `amenity-${index}`);
          })
        })
      }), (info === null || info === void 0 ? void 0 : info.terminal) && /*#__PURE__*/_jsx(ProductDrawerCard, {
        className: dialogCardStyle,
        headingLevel: 3,
        cardTitle: t('loungePerSegmentDialogLocation'),
        children: /*#__PURE__*/_jsx(Text, {
          as: "p",
          children: t('loungePerSegmentDialogTerminalLabel', info.terminal)
        })
      }), (info === null || info === void 0 ? void 0 : info.conditions) && info.conditions.length > 0 && /*#__PURE__*/_jsx(ProductDrawerCard, {
        className: dialogCardStyle,
        headingLevel: 3,
        cardTitle: t('loungePerSegmentDialogCondition'),
        children: info.conditions.map((condition, index) => {
          var _condition$code;
          return /*#__PURE__*/_jsx(Text, {
            as: "p",
            children: condition.description
          }, (_condition$code = condition.code) !== null && _condition$code !== void 0 ? _condition$code : `condition-${index}`);
        })
      })]
    })
  });
};
export default LoungeInfoDialog;
//# sourceMappingURL=LoungeInfoDialog.js.map